import { ZuruflexSession } from '@zuruflex/api-client';
import { currentLocale } from '../i18n.js';

/**
 * The portal's session, created at module load so the access token is in
 * place before React renders. `session.client` refreshes by itself when the
 * short-lived access token expires mid-visit.
 */
export const session = new ZuruflexSession({
  realm: 'PARTNER',
  baseUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:4001',
  locale: currentLocale,
});

export const api = session.client;

/** Empty when no client id is configured; the sign-in page hides the button. */
export const googleClientId: string = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '';
